import { orderDraftRepository } from '@webapp/modules/purchasing/data-access/repositories/OrderDraftRepository'
import { GetPreferredOrderRequestFlowUseCase } from './GetPreferredOrderRequestFlowUseCase'

export const getPreferredOrderRequestFlowUseCase =
  new GetPreferredOrderRequestFlowUseCase({
    orderDraftRepository,
  }).execute
